/* eslint-disable camelcase */
import { lazy, Suspense } from "react";

// Icons
// import Rocket from "assets/icons/info_rocket.svg?react";
// import Bonus from "assets/icons/info_bonus.svg?react";
// import Attention from "assets/icons/info_attention.svg?react";
// import IconGamblGlory from "assets/icons/glory/info_gamb_glory.svg?react";
// import IconGambling from "assets/icons/banger/info_gambling.svg?react";
// import GloryPartners from "assets/icons/glory/glory_partners.svg?react";
// import BangerGloryPartners from "assets/icons/banger/glory_partners.svg?react";
// import NewGloryLock from "assets/icons/glory/new_lock_password.svg?react";
// import NewGloryAccess from "assets/icons/glory/new_access.svg?react";
// import NewGlorySupport from "assets/icons/glory/new_support.svg?react";

// Types
import url from "url/index";
import { PromoType, BonusType } from "../../types/info";

// Icons
const LazyGloryPartners = lazy(
  () => import("assets/icons/glory/glory_partners.svg?react"),
);
const LazyBangerGloryPartners = lazy(
  () => import("assets/icons/banger/glory_partners.svg?react"),
);
const LazyIconGamblGlory = lazy(
  () => import("assets/icons/glory/info_gamb_glory.svg?react"),
);
const LazyIconGambling = lazy(
  () => import("assets/icons/banger/info_gambling.svg?react"),
);
const LazyAttention = lazy(
  () => import("assets/icons/info_attention.svg?react"),
);
const LazyBonus = lazy(() => import("assets/icons/info_bonus.svg?react"));
const LazyRocket = lazy(() => import("assets/icons/info_rocket.svg?react"));

const { VITE_APP_PROJECT_NAME } = import.meta.env;
enum INFO_NAVIGATION_ENUMS {
  ABOUT,
  CONDITIONS,
  KYCAML,
  PRIVACY,
  GAMBLING,
  COOKIES,
  SUPPORT,
  BONUS,
}

export type InfoNavigationType = {
  id: number;
  name: string;
  link: string;
};

export const INFO_NAVIGATION_LIST: InfoNavigationType[] = [
  {
    id: INFO_NAVIGATION_ENUMS.ABOUT,
    name: "info.navigation.about",
    link: url.routes.info.about(),
  },
  {
    id: INFO_NAVIGATION_ENUMS.CONDITIONS,
    name: "info.navigation.rules",
    link: url.routes.info.conditions(),
  },
  {
    id: INFO_NAVIGATION_ENUMS.KYCAML,
    name: "info.navigation.KYCAML",
    link: url.routes.info.kycaml(),
  },
  {
    id: INFO_NAVIGATION_ENUMS.PRIVACY,
    name: "info.navigation.privacy",
    link: url.routes.info.privacy(),
  },
  {
    id: INFO_NAVIGATION_ENUMS.GAMBLING,
    name: "info.navigation.responsiblegame",
    link: url.routes.info.responsiblegame(),
  },
  {
    id: INFO_NAVIGATION_ENUMS.COOKIES,
    name: "info.navigation.cookies",
    link: url.routes.info.cookies(),
  },
  {
    id: INFO_NAVIGATION_ENUMS.SUPPORT,
    name: "info.navigation.support",
    link: url.routes.info.support(),
  },
  {
    id: INFO_NAVIGATION_ENUMS.BONUS,
    name: "menu.left.welcomebonus",
    link: url.routes.info.welcomeBonus(),
  },
];

export const WELCOME_RULE_LIST: PromoType[] = [
  {
    img: (
      <Suspense fallback="">
        <LazyRocket />
      </Suspense>
    ),
    title: "info.promo.welcome.activation.title",
    description_first: "info.promo.welcome.activation.new.description.first",
    description_second: "info.promo.welcome.activation.new.description.second",
    description_third: "info.promo.welcome.activation.new.description.third",
  },
  {
    img: (
      <Suspense fallback="">
        <LazyBonus />
      </Suspense>
    ),
    title: "info.promo.welcome.get.title",
    description_first: `info.promo.welcome.get.new.description.first.${VITE_APP_PROJECT_NAME}`,
    description_second: `info.promo.welcome.get.new.description.second.${VITE_APP_PROJECT_NAME}`,
    description_third: "",
  },
  {
    img: (
      <Suspense fallback="">
        <LazyAttention />
      </Suspense>
    ),
    title: "info.promo.welcome.importantly.title",
    description_first: "info.promo.welcome.importantly.new.description",
    description_second: "",
    description_third: "",
  },
];

export const INFO_ABOUT_LIST = [
  {
    id: 1,
    title: "info.about.partners.gambling",
    description: "info.partners.gambling.desc",
    icon:
      VITE_APP_PROJECT_NAME === "glory" ? (
        <Suspense fallback="">
          <LazyIconGamblGlory />
        </Suspense>
      ) : (
        <Suspense fallback="">
          <LazyIconGambling />
        </Suspense>
      ),
  },
  {
    id: 2,
    title: "footer.partners",
    description: "info.partners.program.desc",
    icon:
      VITE_APP_PROJECT_NAME === "glory" ? (
        <Suspense fallback="">
          <LazyGloryPartners />
        </Suspense>
      ) : (
        <Suspense fallback="">
          <LazyBangerGloryPartners />
        </Suspense>
      ),
  },
];

export const TABLE_LIST: BonusType[] = [
  {
    currency: "AZN",
    min: 5,
    max: 500,
    freeSpins: 40,
  },
  {
    currency: "BDT",
    min: 450,
    max: 27000,
    freeSpins: 800,
  },
  {
    currency: "BRL",
    min: 25,
    max: 1600,
    freeSpins: 25,
  },
  {
    currency: "EUR",
    min: 5,
    max: 300,
    freeSpins: 15,
  },
  {
    currency: "INR",
    min: 300,
    max: 23000,
    freeSpins: 1200,
  },
  {
    currency: "KZT",
    min: 1500,
    max: 140000,
    freeSpins: 6800,
  },
  {
    currency: "PKR",
    min: 1000,
    max: 62000,
    freeSpins: 3000,
  },
  {
    currency: "RUB",
    min: 200,
    max: 20000,
    freeSpins: 1000,
  },
  {
    currency: "TRY",
    min: 125,
    max: 5000,
    freeSpins: 260,
  },
  {
    currency: "USD",
    min: 5,
    max: 300,
    freeSpins: 15,
  },
  {
    currency: "UZS",
    min: 27500,
    max: 3000000,
    freeSpins: 80000,
  },
  {
    currency: "ММK",
    min: 10000,
    max: 60000,
    freeSpins: 30000,
  },
  {
    currency: "KES",
    min: 600,
    max: 20000,
    freeSpins: 1000,
  },
  {
    currency: "LKR",
    min: 1500,
    max: 75000,
    freeSpins: 4500,
  },
  {
    currency: "NPR",
    min: 500,
    max: 27000,
    freeSpins: 1400,
  },
  {
    currency: "KRW",
    min: 15000,
    max: 3000000,
    freeSpins: 30000,
  },
  {
    currency: "GBP",
    min: 15,
    max: 150,
    freeSpins: 25,
  },
  {
    currency: "VND",
    min: 70000,
    max: 5000000,
    freeSpins: 200000,
  },
];
